import { Dialog, Transition } from '@headlessui/react';
import { IconPrinter, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useRef } from 'react';
import { Fragment } from 'react';
import ReactToPrint from 'react-to-print';
import { imageBaseUrl } from '../../config/http';
import ImageComponent from '../../utils/ImageComponent';
import PrintSuratTrxPenjualan from './PrintSuratTrxPenjualan';
import TestingPrint from './TestingPrint';
import SuratKeruak from './SuratKeruak';
import SuratToko from '../../components/surat/SuratToko';

export default function DetailBarangPenjualan({ closeModal, label, detailPenjualan, isOpen, isTertunda }) {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const [openImage, setOpenImage] = useState(false);
  const [load, setLoad] = useState(false);

  const compSurat = useRef();
  function fake() { }

  const harga_modal_jual = detailPenjualan?.total_harga / detailPenjualan?.item?.berat;
  const tipe_surat = localStorage.getItem('tipe_surat');

  const tgl = String(detailPenjualan?.item?.created_at).split(' ');
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
          </Transition.Child>
          {/* {tipe_surat === '1' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <TestingPrint isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          )} */}
          {tipe_surat === '1' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : tipe_surat === '2' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <TestingPrint isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          ) : tipe_surat === '3' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <SuratKeruak isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : tipe_surat === '4' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <SuratToko isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          ) : null}
          {openImage && isOpen && (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20  flex flex-col items-center justify-center">
              <div
                onClick={() => setOpenImage(false)}
                className={'absolute top-52 right-7 lg:top-16 lg:right-[280px] md:right-[120px] md:top-28 '}
              >
                <div className="bg-white p-2 rounded-full cursor-pointer hover:bg-white/50">
                  <IconX />
                </div>
              </div>
              <div>
                {!load && (
                  <div className="max-w-[48px] max-h-[48px]  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                )}
                <img
                  onLoad={() => setLoad(true)}
                  width={''}
                  className={'lg:w-[700px] md:w-[500px] w-[350px] scale-50'}
                  height={''}
                  src={
                    detailPenjualan.item?.gambar1 === null
                      ? ''
                      : `${imageBaseUrl}${detailPenjualan.item?.gambar1[0].asli}`
                  }
                />
              </div>
            </div>
          )}
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-700 px-6 pt-5 pb-5 text-left align-middle shadow-xl transition-all">
                  <div className="flex items-start justify-between border-b border-slate-100 dark:border-slate-700/50 pb-3 mb-4">
                    <Dialog.Title as="h2" className="text-xl font-semibold leading-6 text-slate-900 dark:text-slate-100">
                      {label} <br />
                      <span className="text-sm font-normal text-slate-500 dark:text-slate-400 mt-1 block">
                        KODE FAKTUR : <span className="font-medium text-amber-700 dark:text-amber-500">{detailPenjualan?.kode_trx}</span>
                        &nbsp; | &nbsp; Tanggal : <span className="font-medium text-slate-700 dark:text-slate-300">{detailPenjualan?.created_at}</span>
                      </span>
                    </Dialog.Title>
                    <button
                      onClick={closeModal}
                      className="p-1.5 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:text-slate-300 dark:hover:bg-slate-800 transition-colors focus:outline-none"
                      title="Tutup"
                    >
                      <IconX size={20} stroke={2} />
                    </button>
                  </div>
                  <div className="grid gap-2">
                    <div className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden bg-slate-50 dark:bg-slate-800/30">
                      <div className="p-2.5 border-b border-slate-200 dark:border-slate-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-400 font-semibold px-5">
                        <h2>Detail Transaksi</h2>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex justify-between px-5 items-center">
                        Item
                        <div className="text-slate-900 dark:text-slate-100 text-right">
                          <div className="text-amber-700 dark:text-amber-500 font-semibold">
                            <span className="text-red-500 dark:text-red-400 font-normal">[ {tgl[0]} ]</span> [ {detailPenjualan?.item?.kode_item} - {detailPenjualan?.item?.jenis_kategori?.nama_jenis} ]{' '}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex justify-between px-5 items-center">
                        Berat
                        <div className="text-slate-900 dark:text-slate-100 text-right">
                          <div className="px-2.5 py-1 bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300 rounded-md font-semibold text-xs inline-block">
                            {detailPenjualan?.item?.berat} Gram
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex justify-between px-5 items-center">
                        Emas
                        <div className="text-slate-900 dark:text-slate-100 text-right">
                          <div className="text-amber-700 dark:text-amber-400 font-semibold">{detailPenjualan?.item?.karat} Karat</div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-5 sm:items-center">
                        <div>
                          Harga Modal / gram{' '}
                          <span className="text-red-500 dark:text-red-400 text-[10px] block sm:inline sm:ml-2 font-normal">(* Harga modal saat diinput)</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right mt-1 sm:mt-0">
                          <div className="text-amber-700 dark:text-amber-400 font-semibold">
                            Rp{' '}
                            {numberWithCommas(
                              detailPenjualan?.item?.harga_modal == undefined ? '0' : detailPenjualan?.item?.harga_modal,
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-5 sm:items-center">
                        <div>
                          Harga Jual / gram{' '}
                          <span className="text-red-500 dark:text-red-400 text-[10px] block sm:inline sm:ml-2 font-normal">(* Total harga jual dibagi berat)</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right mt-1 sm:mt-0">
                          <div className="text-amber-700 dark:text-amber-400 font-semibold">
                            Rp{' '}
                            {numberWithCommas(
                              detailPenjualan?.item?.harga_modal == undefined ? '0' : Math.round(harga_modal_jual),
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-bold text-slate-700 dark:text-slate-200 flex justify-between px-5 items-center bg-amber-50/50 dark:bg-slate-800">
                        Total Harga
                        <div className="text-right">
                          <div className="text-amber-600 dark:text-amber-400 text-base">
                            Rp{' '}
                            {numberWithCommas(
                              detailPenjualan?.total_harga == undefined ? '0' : detailPenjualan?.total_harga,
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-5 sm:items-center">
                        <div>
                          Laba Penjualan{' '}
                          <span className="text-red-500 dark:text-red-400 text-[10px] block sm:inline sm:ml-2 font-normal">(* Jika minus (RUGI) dan jika plus (UNTUNG))</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right mt-1 sm:mt-0">
                          <div className={`font-semibold ${detailPenjualan?.laba < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                            Rp{' '}
                            {numberWithCommas(
                              detailPenjualan?.laba == undefined ? '0' : Math.round(detailPenjualan?.laba),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 text-sm font-semibold text-slate-700 dark:text-slate-200 px-1 border border-transparent">
                      Gambar
                      <div className="mt-2 overflow-hidden">
                        {/* {isOpen && (
                            <PhotoView src={
                              detailPenjualan?.item?.gambar1 === null
                                ? ''
                                : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                            }>
                              <img src={
                                detailPenjualan?.item?.gambar1 === null
                                  ? ''
                                  : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                              } alt="" width={'80px'}
                                height={'80px'} srcSet="" />
                            </PhotoView>
                          )} */}
                        {isOpen && (
                          <ImageComponent
                            onClick={() => setOpenImage(true)}
                            className={'max-w-[80px]  hover:scale-110 cursor-pointer'}
                            width={'80px'}
                            height={'80px'}
                            style={{ objectFit: 'cover' }}
                            src={
                              detailPenjualan?.item?.gambar1 === null
                                ? ''
                                : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div className="mt-4 pt-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-2">
                      <button
                        onClick={closeModal}
                        className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors focus:outline-none"
                      >
                        Tutup
                      </button>
                      <ReactToPrint
                        trigger={() => (
                          <button className="px-5 py-2 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 dark:bg-amber-500 dark:hover:bg-amber-600 rounded-md shadow-sm transition-colors focus:outline-none border border-transparent inline-flex items-center gap-1.5">
                            <IconPrinter size={16} stroke={2} />
                            Cetak Struk
                          </button>
                        )}
                        content={() => compSurat.current}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
